import React, { useState, useEffect } from "react";
import MyDialog from "../components/MyDialog";
import { useSelector, useDispatch } from "react-redux";
import MyTable from "../components/MyTable";
import AddIcon from "@mui/icons-material/Add";
import MyConfirmation from "../components/MyConfirmation";
import MyButton from "../components/MyButton";
import ClientFournisseurForm from "../components/forms/ClientFournisseurForm";
import { showSnackbar } from "../store/snackbarSlice";
import {
  fetchClientsFournisseurs,
  clearAlerts,
  deleteClientFournisseur,
  setSelectedClientFournisseur,
  clearSelectedClientFournisseur,
} from "../store/clientFournisseurSlice";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ACTION_PERMISSIONS, TiersType } from "../services/Enums";

export default function ClientFournisseur() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ConfirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(TiersType.CLIENT); // Add state for selected type

  const dispatch = useDispatch();
  const {
    clientsFournisseursData,
    pagination,
    selectedClientFournisseur,
    message,
    error,
  } = useSelector((state) => state.clientFournisseur);

  useEffect(() => {
    if (message || error) {
      const type = message ? "success" : "error";
      const content = message || error;

      // Show snackbar with appropriate type
      dispatch(showSnackbar({ message: content, severity: type }));
      dispatch(clearAlerts());

      // Clear the form and fetch articles if successful
      if (message) {
        // Optionally refresh data or reset the form
      }
    }
  }, [message, error, dispatch]);

  useEffect(() => {
    dispatch(
      fetchClientsFournisseurs({ page: 1, limit: 5, type: selectedType })
    );

    return () => {
      dispatch(clearSelectedClientFournisseur());
    };
  }, [dispatch, selectedType]); // Trigger data fetch when selectedType changes

  const actions = [
    {
      label: "Edit",
      type: "update",
      action:ACTION_PERMISSIONS.EDIT_CLIENT,
      callback: (item) => {
        dispatch(setSelectedClientFournisseur(item));
        openDialog();
      },
    },
    {
      label: "Delete",
      type: "delete",
      action:ACTION_PERMISSIONS.DELETE_CLIENT,
      callback: (item) => {
        dispatch(setSelectedClientFournisseur(item));
        handleOpenConfirmDialog();
      },
    },
  ];

  const handlePageChange = (newPage, newRowsPerPage) => {
    dispatch(
      fetchClientsFournisseurs({
        page: newPage + 1,
        limit: newRowsPerPage,
        type: selectedType,
      })
    );
  };

  const headers = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "address", label: "Address" },
    { key: "phone", label: "Phone" },
  ];

  const openDialog = () => {
    setDialogOpen(true); // Open the dialog
  };

  const closeDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleConfirm = () => {
    dispatch(deleteClientFournisseur(selectedClientFournisseur._id));
    setConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setConfirmDialogOpen(false);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedType(value); // Update the selected type
    dispatch(fetchClientsFournisseurs({ page: 1, limit: 5, type: value })); // Dispatch action
  };
  return (
    <div className="articleMainDiv">
      <div className="btnDiv">
        <MyButton type="create" action={ACTION_PERMISSIONS.ADD_CLIENT} onClick={openDialog}>
          <AddIcon /> New Client/Fournisseur
        </MyButton>
        <FormControl fullWidth margin="normal">
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            labelId="type-label"
            name="type"
            value={selectedType}
            onChange={handleChange}
          >
            {Object.entries(TiersType).map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {" "}
                {/* Use value instead of key */}
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <MyDialog
        open={dialogOpen}
        title={
          selectedClientFournisseur
            ? "Update Client/Fournisseur"
            : "Create Client/Fournisseur"
        }
        onDiscard={closeDialog}
      >
        <ClientFournisseurForm closeDialog={closeDialog} />
      </MyDialog>

      <h2>Client Fournisseur Data</h2>
      <div className="tableDiv">
        <div style={{ width: "100%" }}>
          <MyTable
            headers={headers}
            totalRows={pagination?.total || 0}
            data={clientsFournisseursData}
            actions={actions}
            defaultPageSize={5}
            onPageChange={handlePageChange}
          />
          <MyConfirmation
            open={ConfirmDialogOpen}
            title="Delete Item"
            description={`Are you sure you want to delete this item? ${
              selectedClientFournisseur?.name || ""
            }`}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            confirmText="Delete"
            cancelText="Cancel"
          />
        </div>
      </div>
    </div>
  );
}
